/* eslint-disable no-console */
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './routes/Routes'

import { Box, ChakraProvider } from '@chakra-ui/react'
import { theme } from './components/theme'
import RootStore from './store/RootStore'

import Fonts from './components/ui/Fonts'
import { SignInUnavailable } from './components/ui/SignInUnavailable'
import { IDENTITY_CONFIG } from './auth/utils/authConst'

import './setupHighcharts'
import { AuthProvider } from './auth/providers/authProvider'
import { ErrorBoundary } from './ErrorBoundary'
import { QueryClient } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
})

const persister = createSyncStoragePersister({
  storage: window.localStorage,
})

function App() {
  window.rootStore = RootStore

  // The sign-in service address is baked in at build time. If it is missing, oidc-client cannot
  // reach any identity server and stores no token, so the app would otherwise render an empty
  // page and send every request unauthenticated. Stop here and say so instead.
  if (!IDENTITY_CONFIG.stsAuthority) {
    console.error(
      'REACT_APP_STS_AUTHORITY is not set for this build, so sign-in cannot work. ' +
        'Add it to the .env file this build uses (.env, .env.staging or .env.production) ' +
        'and rebuild.'
    )

    return (
      <ChakraProvider theme={theme}>
        <Fonts />
        <SignInUnavailable />
      </ChakraProvider>
    )
  }

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}>
      <ChakraProvider theme={theme}>
        <Fonts />
        <BrowserRouter basename="/">
          <ErrorBoundary fallback={<Box>Something went wrong</Box>}>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </ChakraProvider>

      <Box
        position="fixed"
        right="5px"
        bottom="5px"
        zIndex="999"
        fontSize="10"
        color="#999999"
        textAlign="end">
        <br />v{RootStore.version}
      </Box>
    </PersistQueryClientProvider>
  )
}

export default App
